export const GROUP_TYPE_NIUM = 'nium';
export const GROUP_TYPE_VERTO = 'verto';
